import { Box, Text } from '@chakra-ui/react';

export const SelectPreview = () => {
  return (
    <Box>
      <Text>SelectPreview - Coming soon</Text>
    </Box>
  );
};
